import styled from 'styled-components';
const MapContainer = styled.div `
  canvas {
  }
`;
export default MapContainer;
